import React from 'react';
import { Group, Text, Image } from 'react-konva';
import useImage from 'use-image';

export default function URLImage({ image, ...props }) {
    const [img] = useImage(image.src);
    return (
        <Group x={image.x} y={image.y} offsetX={img ? img.width / 2 : 0} offsetY={img ? img.height / 2 : 0} draggable {...props}>
            <Text text={image.shortName} align="center" wrap="word" fill={image?.isBooked ? '#ff0000' : '#000000'} />
            <Image image={img} />
        </Group>
    );
}
